/* Cupking theme — interactions */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var q = item.querySelector('.faq-item__q');
      var a = item.querySelector('.faq-item__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---- Helpers ---- */
  function money(symbol, amount) {
    return symbol + ' ' + amount.toFixed(2).replace('.', ',');
  }

  /* ---- Configurator ---- */
  function initConfigurator() {
    var root = document.querySelector('[data-configurator]');
    if (!root) return;

    var symbol = root.getAttribute('data-currency') || '€';
    var minQty = parseInt(root.getAttribute('data-min-qty'), 10) || 100;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var nextBtn = root.querySelector('[data-next]');
    var prevBtn = root.querySelector('[data-prev]');
    var counter = root.querySelector('[data-step-counter]');
    var total = steps.length;
    var current = 0;

    /* --- Variants (productkoppeling) --- */
    var variants = [];
    var vEl = root.querySelector('[data-cup-variants]');
    if (vEl) {
      try { variants = JSON.parse(vEl.textContent); } catch (e) { variants = []; }
    }
    function variantForType(label) {
      if (!variants.length) return null;
      var match = variants.filter(function (v) {
        return v.title && v.title.toLowerCase().indexOf(label.toLowerCase()) !== -1;
      });
      var pool = match.length ? match : variants;
      var avail = pool.filter(function (v) { return v.available; });
      return (avail[0] || pool[0]) || null;
    }

    /* --- Surcharges (toeslag-producten, prijs per stuk in centen) --- */
    var surcharges = {};
    var sEl = root.querySelector('[data-cup-surcharges]');
    if (sEl) {
      try { surcharges = JSON.parse(sEl.textContent) || {}; } catch (e) { surcharges = {}; }
    }
    // Lijst van actieve toeslagen op basis van de huidige keuzes
    function activeSurcharges() {
      var list = [];
      if (state.text && surcharges.text) list.push({ key: 'text', sc: surcharges.text, label: surcharges.text.label || 'Opdruktekst' });
      if (state.logoName && surcharges.logo) list.push({ key: 'logo', sc: surcharges.logo, label: surcharges.logo.label || 'Logo-opdruk' });
      var pk = state.print.key;
      if (pk && surcharges[pk]) list.push({ key: pk, sc: surcharges[pk], label: surcharges[pk].label || (pk + ' print') });
      return list;
    }

    /* --- State --- */
    var state = {
      type: { label: 'Original', unit: 0.49 },
      kleur: { label: 'Transparant', color: 0xeef2f0, opacity: 0.35 },
      print: { label: '1 kleur', key: '' },
      text: '',
      logoName: '',
      logoFile: null,
      qty: minQty
    };

    /* --- 3D preview --- */
    var cup = null;
    var mount = root.querySelector('[data-cup3d]');
    if (mount && window.CupKing3D) {
      cup = window.CupKing3D.create(mount);
      if (cup) {
        cup.setColor(state.kleur.color, state.kleur.opacity);
        window.addEventListener('resize', function () { cup.resize(); });
      }
    }
    function textColorForCup() {
      return state.kleur.color === 0x1b3a2b ? '#ffffff' : '#1b3a2b';
    }
    function refreshDecoration() {
      if (cup) cup.setText(state.text, textColorForCup());
    }

    /* --- Price --- */
    var priceTotal = root.querySelector('[data-price-total]');
    var priceUnit = root.querySelector('[data-price-unit]');
    var priceCaption = root.querySelector('[data-price-caption]');
    function basePrice() {
      var v = variantForType(state.type.label);
      if (v && typeof v.price === 'number') return v.price / 100;
      return state.type.unit;
    }
    function surchargeTotal() {
      return activeSurcharges().reduce(function (sum, s) { return sum + (s.sc.price / 100); }, 0);
    }
    function currentUnit() {
      return basePrice() + surchargeTotal();
    }
    function renderPrice() {
      var unit = currentUnit();
      if (priceUnit) priceUnit.textContent = money(symbol, unit);
      if (priceTotal) priceTotal.textContent = money(symbol, unit * state.qty);
      if (priceCaption) priceCaption.textContent = 'voor ' + state.qty + ' stuks';
    }

    /* --- Option cards --- */
    root.querySelectorAll('[data-option]').forEach(function (card) {
      card.addEventListener('click', function () {
        var group = card.getAttribute('data-group');
        root.querySelectorAll('[data-option][data-group="' + group + '"]').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        var label = card.getAttribute('data-label') || card.textContent.trim();

        if (group === 'type') {
          state.type = { label: label, unit: parseFloat(card.getAttribute('data-unit-price')) || 0 };
        } else if (group === 'kleur') {
          var color = parseInt(card.getAttribute('data-color'), 16);
          var op = parseFloat(card.getAttribute('data-opacity'));
          state.kleur = { label: label, color: color, opacity: isNaN(op) ? 1 : op };
          if (cup) cup.setColor(state.kleur.color, state.kleur.opacity);
          refreshDecoration();
        } else if (group === 'print') {
          state.print = { label: label, key: card.getAttribute('data-surcharge-key') || '' };
        }
        renderPrice();
      });
    });

    /* --- Text input --- */
    var textInput = root.querySelector('[data-design-text]');
    if (textInput) {
      textInput.addEventListener('input', function () {
        state.text = textInput.value;
        refreshDecoration();
        renderPrice();
      });
    }

    /* --- Logo upload --- */
    var logoInput = root.querySelector('[data-design-logo]');
    var logoStatus = root.querySelector('[data-logo-status]');
    var logoNameEl = root.querySelector('[data-logo-name]');
    var logoRemove = root.querySelector('[data-logo-remove]');
    if (logoInput) {
      logoInput.addEventListener('change', function () {
        var file = logoInput.files && logoInput.files[0];
        if (!file) return;
        state.logoName = file.name;
        state.logoFile = file;
        if (logoNameEl) logoNameEl.textContent = file.name;
        if (logoStatus) logoStatus.hidden = false;
        renderPrice();
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = new Image();
          img.onload = function () { if (cup) cup.setLogo(img); };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    }
    if (logoRemove) {
      logoRemove.addEventListener('click', function () {
        state.logoName = '';
        state.logoFile = null;
        if (logoInput) logoInput.value = '';
        if (logoStatus) logoStatus.hidden = true;
        if (cup) cup.setLogo(null);
        renderPrice();
      });
    }

    /* --- Quantity --- */
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyNote = root.querySelector('[data-qty-note]');
    function clampQty() {
      var n = parseInt(qtyInput ? qtyInput.value : state.qty, 10);
      if (isNaN(n)) n = minQty;
      if (n < minQty) {
        n = minQty;
        if (qtyNote) qtyNote.textContent = 'Minimaal ' + minQty + ' stuks per ontwerp.';
      }
      state.qty = n;
      if (qtyInput) qtyInput.value = n;
      renderPrice();
    }
    if (qtyInput) {
      qtyInput.setAttribute('min', minQty);
      qtyInput.value = minQty;
      qtyInput.addEventListener('change', clampQty);
      qtyInput.addEventListener('blur', clampQty);
    }
    var qMinus = root.querySelector('[data-qty-minus]');
    var qPlus = root.querySelector('[data-qty-plus]');
    if (qMinus) qMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(minQty, (parseInt(qtyInput.value, 10) || minQty) - 50); clampQty();
    });
    if (qPlus) qPlus.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || minQty) + 50; clampQty();
    });

    /* --- Summary --- */
    var scContainer = root.querySelector('[data-summary-surcharges]');
    function fillSummary() {
      function set(key, val) {
        var el = root.querySelector('[data-sum="' + key + '"]');
        if (el) el.textContent = val;
      }
      set('type', state.type.label);
      set('kleur', state.kleur.label);
      set('tekst', state.text || '—');
      set('logo', state.logoName || '—');
      set('print', state.print.label);
      set('aantal', state.qty + ' stuks');
      set('basis', money(symbol, basePrice()) + ' p/stuk');
      if (scContainer) {
        scContainer.innerHTML = activeSurcharges().map(function (s) {
          return '<div class="config-summary__row"><span>+ ' + s.label + '</span><strong>' +
            money(symbol, s.sc.price / 100) + ' p/stuk</strong></div>';
        }).join('');
      }
      set('totaal', money(symbol, currentUnit() * state.qty));
    }

    /* --- Add to cart --- */
    var cartError = root.querySelector('[data-cart-error]');
    function showError(msg) {
      if (!cartError) { alert(msg); return; }
      cartError.textContent = msg;
      cartError.hidden = false;
    }
    function jsonAdd(body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Toevoegen mislukt'); });
        return r.json();
      });
    }
    // Stuurt de hoofdregel inclusief logo-bestand via een echte multipart-form-post.
    function submitMainWithFile(variantId, props) {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.enctype = 'multipart/form-data';
      form.style.display = 'none';
      function hidden(name, value) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = name; i.value = value; form.appendChild(i);
      }
      hidden('id', variantId);
      hidden('quantity', state.qty);
      hidden('return_to', '/cart');
      Object.keys(props).forEach(function (k) { hidden('properties[' + k + ']', props[k]); });
      // Verplaats het échte file-input-element zodat het bestand meegaat
      logoInput.name = 'properties[Ontwerpbestand]';
      form.appendChild(logoInput);
      document.body.appendChild(form);
      form.submit();
    }

    function addToCart() {
      if (cartError) cartError.hidden = true;
      var variant = variantForType(state.type.label);
      if (!variant) {
        showError('Bestellen is nog niet geactiveerd: koppel een basisproduct in de thema-editor (sectie Configurator).');
        return;
      }
      nextBtn.disabled = true;
      nextBtn.textContent = 'Bezig…';

      var code = 'CK-' + Date.now().toString(36).toUpperCase();
      var props = {
        'Ontwerp-ID': code,
        'Bekertype': state.type.label,
        'Kleur': state.kleur.label,
        'Opdruktekst': state.text || 'Geen',
        'Logo': state.logoName || 'Geen',
        'Print': state.print.label
      };
      // Toeslagen als losse regels (× aantal), gekoppeld via Ontwerp-ID
      var scItems = activeSurcharges()
        .filter(function (s) { return s.sc && s.sc.id; })
        .map(function (s) {
          return { id: s.sc.id, quantity: state.qty, properties: { 'Toeslag voor': s.label, 'Hoort bij ontwerp': code } };
        });

      Promise.resolve()
        .then(function () { return scItems.length ? jsonAdd({ items: scItems }) : null; })
        .then(function () {
          if (state.logoFile) {
            // Hoofdregel + bestand via form-post (navigeert naar /cart)
            submitMainWithFile(variant.id, props);
          } else {
            return jsonAdd({ id: variant.id, quantity: state.qty, properties: props })
              .then(function () { window.location.href = '/cart'; });
          }
        })
        .catch(function (err) {
          showError(err.message || 'Er ging iets mis bij het toevoegen aan de winkelwagen.');
          nextBtn.disabled = false;
          nextBtn.textContent = 'Bestel afronden';
        });
    }

    /* --- Step navigation --- */
    function render() {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
        s.classList.toggle('is-done', i < current);
      });
      panels.forEach(function (p, i) { p.hidden = i !== current; });
      if (counter) counter.textContent = 'Stap ' + (current + 1) + ' van ' + total;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.textContent = current === total - 1 ? 'Bestel afronden' : 'Volgende →';
      if (current === total - 1) fillSummary();
    }
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (current < total - 1) { current++; render(); }
      else { addToCart(); }
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; render(); }
    });
    steps.forEach(function (s, i) {
      s.addEventListener('click', function () { current = i; render(); });
    });

    /* --- Preview tools --- */
    root.querySelectorAll('[data-tool]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tool = btn.getAttribute('data-tool');
        if (tool === 'reset' && cup) {
          cup.targetRotY = 0; cup.autoRotate = true;
        } else if (tool === 'download' && cup) {
          var url = cup.toDataURL();
          if (url) {
            var a = document.createElement('a');
            a.href = url; a.download = 'cupking-ontwerp.png';
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
          }
        } else if (tool === 'fullscreen') {
          var box = root.querySelector('.config-preview');
          if (!document.fullscreenElement && box && box.requestFullscreen) {
            box.requestFullscreen().then(function () { if (cup) setTimeout(function () { cup.resize(); }, 100); });
          } else if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      });
    });
    document.addEventListener('fullscreenchange', function () { if (cup) setTimeout(function () { cup.resize(); }, 100); });

    // Toon toeslag-bedragen in stap 3 (hints) en stap 4 (printkaarten)
    function initSurchargeLabels() {
      ['text', 'logo'].forEach(function (k) {
        var hint = root.querySelector('[data-surcharge-hint="' + k + '"]');
        if (hint && surcharges[k]) {
          hint.textContent = '+ ' + money(symbol, surcharges[k].price / 100) + ' p/stuk';
          hint.hidden = false;
        }
      });
      root.querySelectorAll('[data-group="print"]').forEach(function (card) {
        var key = card.getAttribute('data-surcharge-key');
        var el = card.querySelector('[data-print-price]');
        if (!el) return;
        if (key && surcharges[key]) el.textContent = '+ ' + money(symbol, surcharges[key].price / 100) + ' p/stuk';
        else el.textContent = 'inbegrepen';
      });
    }
    initSurchargeLabels();

    renderPrice();
    render();
  }

  /* ---- Quantity steppers (product + cart) ---- */
  function initQtySteppers() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 0;

      function update() {
        var n = parseInt(input.value, 10);
        if (isNaN(n)) n = min;
        if (n < min) n = min;
        input.value = n;
        // Product page: live "stuks totaal" + hidden Totaal aantal
        var form = input.closest('form');
        var kratEl = form ? form.querySelector('[data-krat-size]') : null;
        if (kratEl) {
          var krat = parseInt(kratEl.getAttribute('data-krat-size'), 10) || 0;
          var totalStuks = n * krat;
          var disp = form.querySelector('[data-qty-display]');
          var totalDisp = form.querySelector('[data-total-display]');
          var label = form.querySelector('[data-krat-label]');
          if (disp) disp.textContent = n;
          if (totalDisp) totalDisp.textContent = totalStuks.toLocaleString('nl-NL');
          if (label) label.textContent = n === 1 ? 'krat' : 'kratten';
          if (kratEl.name) kratEl.value = totalStuks.toLocaleString('nl-NL') + ' stuks';
        }
        // Cart line: live "stuks totaal"
        var line = input.closest('[data-cart-line]');
        if (line) {
          var st = line.querySelector('[data-total-stuks]');
          if (st) {
            var ks = parseInt(st.getAttribute('data-krat-size'), 10) || 0;
            st.textContent = n * ks;
          }
        }
      }
      // Stepper buttons set the value, run the live update, then fire `change`
      // so the cart-AJAX listener (and native handlers) pick it up.
      function step(delta) {
        input.value = (parseInt(input.value, 10) || min) + delta;
        update();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      update();
    });
  }

  /* ---- Product form: line item properties + AJAX toevoegen (zoals bekershuren) ---- */
  function initProductForm() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      var qty = form.querySelector('input[name="quantity"]');
      var tot = form.querySelector('[name="properties[Totaal aantal]"]');
      var krat = tot ? (parseInt(tot.getAttribute('data-krat-size'), 10) || 1) : 1;

      // Houd "Totaal aantal" altijd actueel (ook zonder dat de bezoeker het aantal aanraakt)
      function sync() {
        if (!qty || !tot) return;
        var n = parseInt(qty.value, 10) || 1;
        tot.value = (n * krat).toLocaleString('nl-NL') + ' stuks';
      }
      sync();
      if (qty) { qty.addEventListener('input', sync); qty.addEventListener('change', sync); }

      // AJAX toevoegen → eigenschappen (Krat, Totaal aantal, Prijs per stuk) gaan gegarandeerd mee
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        sync();
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.textContent = 'Bezig…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Toevoegen mislukt'); });
            return r.json();
          })
          .then(function () { window.location.href = '/cart'; })
          .catch(function (err) {
            if (btn) { btn.disabled = false; if (btn.dataset.label) btn.innerHTML = btn.dataset.label; }
            alert(err.message || 'Er ging iets mis bij het toevoegen aan de winkelwagen.');
          });
      });
    });
  }

  /* ---- Money helper (cents → "€ 1.234,56") ---- */
  function formatCents(cents) {
    return '€ ' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---- Cart: auto-update on quantity change (AJAX) ---- */
  function initCartAjax() {
    var cartForm = document.querySelector('.cart-page');
    if (!cartForm) return;

    var timer = null;
    function renderCart(cart) {
      // Header count
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      // Empty → reload to show empty state
      if (cart.item_count === 0) { window.location.reload(); return; }
      // Update each line + remove lines no longer present
      var presentKeys = {};
      cart.items.forEach(function (item) {
        presentKeys[item.key] = true;
        var line = document.querySelector('[data-cart-line="' + item.key + '"]');
        if (!line) return;
        var priceEl = line.querySelector('.cart-line__price strong');
        if (priceEl) priceEl.textContent = formatCents(item.final_line_price);
        var st = line.querySelector('[data-total-stuks]');
        if (st) {
          var ks = parseInt(st.getAttribute('data-krat-size'), 10) || 0;
          st.textContent = item.quantity * ks;
        }
        var qtyInput = line.querySelector('input[name^="updates["]');
        if (qtyInput && parseInt(qtyInput.value, 10) !== item.quantity) qtyInput.value = item.quantity;
      });
      document.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var key = line.getAttribute('data-cart-line');
        if (!presentKeys[key]) line.remove();
      });
      // Subtotal (first summary line)
      var sub = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatCents(cart.total_price);
    }

    function changeLine(key, quantity) {
      var note = document.querySelector('.cart-summary');
      if (note) note.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); })
        .catch(function () { window.location.reload(); })
        .then(function () { if (note) note.classList.remove('is-busy'); });
    }

    cartForm.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.name || input.name.indexOf('updates[') !== 0) return;
      var line = input.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-cart-line');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      clearTimeout(timer);
      timer = setTimeout(function () { changeLine(key, qty); }, 250);
    });
  }

  /* ---- Cart: date pickers (werkdagen + retour max 5 werkdagen) ---- */
  function initCartDates() {
    var deliveryInput = document.getElementById('delivery-date');
    var returnInput = document.getElementById('return-date');
    if (!deliveryInput || !returnInput) return;

    var checkoutBtn = document.querySelector('button[name="checkout"]');
    var MIN_RENTAL_WORKDAYS = 1;   // retour minimaal 1 werkdag na levering
    var MAX_RENTAL_WORKDAYS = 5;   // retour maximaal 5 werkdagen na levering
    var CUTOFF_HOUR = 16;

    // Nederlandse feestdagen (geen bezorging/ophalen)
    var HOLIDAYS = {
      '2026-01-01': 1, '2026-04-03': 1, '2026-04-06': 1, '2026-04-27': 1, '2026-05-14': 1, '2026-05-25': 1, '2026-12-25': 1, '2026-12-26': 1,
      '2027-01-01': 1, '2027-03-26': 1, '2027-03-29': 1, '2027-04-27': 1, '2027-05-06': 1, '2027-05-17': 1, '2027-12-25': 1, '2027-12-26': 1,
      '2028-01-01': 1, '2028-04-14': 1, '2028-04-17': 1, '2028-04-27': 1, '2028-05-25': 1, '2028-06-05': 1, '2028-12-25': 1, '2028-12-26': 1
    };

    function todayStr() {
      var t = new Date();
      return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
    }
    function addDays(dateStr, days) {
      var p = dateStr.split('-').map(Number);
      var date = new Date(p[0], p[1] - 1, p[2]);
      date.setDate(date.getDate() + days);
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    }
    function dayOfWeek(dateStr) {
      var p = dateStr.split('-').map(Number);
      return new Date(p[0], p[1] - 1, p[2]).getDay();
    }
    function whyInvalid(dateStr) {
      if (!dateStr) return false;
      var day = dayOfWeek(dateStr);
      if (day === 0 || day === 6) return 'weekend';
      if (HOLIDAYS[dateStr]) return 'feestdag';
      return false;
    }
    function nextValid(dateStr) {
      var s = dateStr;
      while (whyInvalid(s)) s = addDays(s, 1);
      return s;
    }
    // n werkdagen vooruit (telt alleen werkdagen, slaat weekend/feestdag over)
    function addWorkdays(dateStr, n) {
      var s = dateStr, counted = 0;
      while (counted < n) {
        s = addDays(s, 1);
        if (!whyInvalid(s)) counted++;
      }
      return s;
    }
    // aantal werkdagen tussen twee datums (exclusief startdatum)
    function workdaysBetween(fromStr, toStr) {
      if (!fromStr || !toStr || toStr <= fromStr) return 0;
      var s = fromStr, count = 0;
      while (s < toStr) {
        s = addDays(s, 1);
        if (!whyInvalid(s)) count++;
      }
      return count;
    }
    function calcMinDeliveryStr() {
      var baseDays = new Date().getHours() >= CUTOFF_HOUR ? 2 : 1;
      return nextValid(addDays(todayStr(), baseDays));
    }

    var minDeliveryStr = calcMinDeliveryStr();
    deliveryInput.min = minDeliveryStr;
    if (deliveryInput.value && (deliveryInput.value < minDeliveryStr || whyInvalid(deliveryInput.value))) {
      deliveryInput.value = '';
    }

    function syncReturnRange() {
      if (deliveryInput.value) {
        returnInput.min = addWorkdays(deliveryInput.value, MIN_RENTAL_WORKDAYS);
        returnInput.max = addWorkdays(deliveryInput.value, MAX_RENTAL_WORKDAYS);
      } else {
        returnInput.min = addWorkdays(minDeliveryStr, MIN_RENTAL_WORKDAYS);
        returnInput.removeAttribute('max');
      }
    }

    var wrap = document.querySelector('.cart-dates');
    function clearError() {
      if (!wrap) return;
      var e = wrap.querySelector('.cart-dates__error');
      if (e) e.remove();
      wrap.classList.remove('cart-dates--invalid');
    }
    function showError(msg) {
      if (!wrap) return;
      clearError();
      var e = document.createElement('p');
      e.className = 'cart-dates__error';
      e.textContent = msg;
      wrap.appendChild(e);
      wrap.classList.add('cart-dates--invalid');
    }

    function validateDelivery() {
      clearError();
      var v = deliveryInput.value;
      if (!v) { if (checkoutBtn) checkoutBtn.disabled = true; return false; }
      var inv = whyInvalid(v);
      if (inv) {
        showError(inv === 'weekend' ? 'We bezorgen niet in het weekend. Kies een werkdag.' : 'We bezorgen niet op een feestdag. Kies een werkdag.');
        deliveryInput.value = '';
        if (checkoutBtn) checkoutBtn.disabled = true;
        return false;
      }
      if (v < minDeliveryStr) {
        showError(new Date().getHours() >= CUTOFF_HOUR
          ? 'Bestellingen na 16:00 worden pas over twee werkdagen bezorgd. Kies een latere datum.'
          : 'Deze bezorgdatum is niet meer beschikbaar. Kies een latere datum.');
        deliveryInput.value = '';
        if (checkoutBtn) checkoutBtn.disabled = true;
        return false;
      }
      return true;
    }

    function validateReturn() {
      clearError();
      var d = deliveryInput.value, r = returnInput.value;
      if (!r) { if (checkoutBtn) checkoutBtn.disabled = true; return false; }
      var inv = whyInvalid(r);
      if (inv) {
        showError(inv === 'weekend' ? 'We halen niet op in het weekend. Kies een werkdag.' : 'We halen niet op op een feestdag. Kies een werkdag.');
        returnInput.value = '';
        if (checkoutBtn) checkoutBtn.disabled = true;
        return false;
      }
      if (!d) { if (checkoutBtn) checkoutBtn.disabled = true; return false; }
      var diff = workdaysBetween(d, r);
      if (diff < MIN_RENTAL_WORKDAYS) {
        showError('Retourdatum moet minimaal ' + MIN_RENTAL_WORKDAYS + ' werkdag na de bezorgdatum zijn.');
        if (checkoutBtn) checkoutBtn.disabled = true;
        return false;
      }
      if (diff > MAX_RENTAL_WORKDAYS) {
        showError('Retourdatum mag maximaal ' + MAX_RENTAL_WORKDAYS + ' werkdagen na de bezorgdatum zijn.');
        if (checkoutBtn) checkoutBtn.disabled = true;
        return false;
      }
      if (checkoutBtn) checkoutBtn.disabled = false;
      return true;
    }

    function fullValidate() {
      if (!validateDelivery()) { if (checkoutBtn) checkoutBtn.disabled = true; return false; }
      return validateReturn();
    }

    function saveDates() {
      if (!fullValidate()) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { Bezorgdatum: deliveryInput.value, Retourdatum: returnInput.value } })
      }).catch(function () {});
    }

    deliveryInput.addEventListener('change', function () {
      var ok = validateDelivery();
      syncReturnRange();
      if (returnInput.value) ok = validateReturn() && ok;
      if (ok) saveDates();
    });
    returnInput.addEventListener('change', function () {
      if (validateReturn()) saveDates();
    });

    syncReturnRange();
    fullValidate();
  }

  /* ---- PDP gallery thumbs ---- */
  function initPdpGallery() {
    var main = document.querySelector('[data-pdp-main]');
    var thumbs = document.querySelector('[data-pdp-thumbs]');
    if (!main || !thumbs) return;
    thumbs.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-image');
        if (src) main.src = src;
        thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initFaq();
    initConfigurator();
    initQtySteppers();
    initProductForm();
    initPdpGallery();
    initCartAjax();
    initCartDates();
  });
})();
